import { passwordValidation } from '@nginformatica/ngi-core/lib/password-validation'

export const getPaths = (t: (key: string) => string) => ({
    '-': t('portal:breadcrumbs:home'),
    'clinical-questionnaires': t('portal:breadcrumbs:clinicalQuestionnaires'),
    consultations: t('portal:breadcrumbs:consultations'),
    details: t('portal:breadcrumbs:consultationDetails'),
    epis: t('portal:breadcrumbs:ppe'),
    equipment: t('portal:breadcrumbs:ppeDetails'),
    risks: t('portal:breadcrumbs:risks'),
    detail: t('portal:breadcrumbs:riskDetails'),
    'safety-questionnaires': t('portal:breadcrumbs:safetyQuestionnaires'),
    answer: t('portal:breadcrumbs:answer'),
    update: t('portal:breadcrumbs:update'),
    view: t('portal:breadcrumbs:view'),
    'my-account': t('portal:breadcrumbs:myAccount')
})

export default (password: string) =>
    passwordValidation({
        password,
        options: [
            'min',
            'uppercase',
            'lowercase',
            'symbols',
            'digits',
            'sequential'
        ],
        config: { length: { minLength: 8 } }
    })
